module.exports = "/images/marriage-background.png?3281317d5835eb33c80f2ea2f88f8603";